import {VGLawCookie} from "vglawcookie";

window.VegasListener = {
	onReady: () => {
		Vegas.carousel();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.serieDescription();
		Vegas.initHeader();
		Vegas.fixedScrollTo($(window));
	},

	onLoad: () => {
		Vegas.preloader();
		Vegas.measureHeader();
		Vegas.fixedHeader($(window));
	},

	onClick: () => {
		Vegas.popup();
	},

	onScroll: ($self) => {
		Vegas.fixedScrollTo($self);
		Vegas.fixedHeader($self);
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization","color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},

	preloader: function () {

	},

	enablePlugins: function () {
		// navigation
		new VGNav({
			expand: 'lg',
			isHover: true
		});

		// Nice Select
		$('.nice-select').niceSelect();

		// Tooltip
		$('.tooltip').niceSelect();

		// Twentytwenty
		let $twentytwenty = $('.vg-beforeAfter');
		if ($twentytwenty.length) {
			$twentytwenty.twentytwenty({
				before_label: 'До', // Set a custom before label
				after_label: 'После', // Set a custom after label
			});
		}

		new VGLawCookie({
			enableLinkMore: true,
		});
	},

	popup: function () {
		$('[data-modal]').click(function () {
			ModalVegas.init($(this));

			return false;
		});
	},

	carousel: function () {
		VegasCarousel.init();
	},

	other: function () {
		// default page
		let $pageText = $('.vg-page-default, .page-default'),
			$table = $pageText.find('table');

		$table.addClass('table table-hover table-striped');
		$table.wrap('<div class="table-responsive"></div>');
		//$pageText.find('br').after('<span class="mb-5 d-block"></span>');
		$pageText.find('img').addClass('img-fluid');
		$pageText.find('figure.image[data-fancybox] img, img[data-fancybox], a[data-fancybox] img').each(function () {
			const $image = $(this);
			let $link = $image.closest('a');
			if (!$link.length) {
				$image.wrap($('<a>').attr('href', $image.attr('src')).attr('data-fancybox', ''));
				$link = $image.closest('a');
			} else {
				if (!$link.is('[data-fancybox]')) $link.attr('href', $image.attr('src'));
				// Старые записи могли сохранять отметку Fancybox с пустым адресом ссылки.
				$link.attr('data-fancybox', $link.attr('data-fancybox') || '');
				if (!$link.attr('href')) $link.attr('href', $image.attr('src'));
			}

			if (!$link.is('[data-caption]')) {
				const $caption = $image.closest('figure.image').children('figcaption').first();
				if ($caption.length) {
					$link.attr('data-caption', $caption.html().trim());
				}
			}
		});

		//
		let $individualSizes = $('[data-toggle="individual"]');
		if ($individualSizes.length) {
			$individualSizes.on('click', function () {
				let $self = $(this),
					$formSeries = $('#form-individual-sizes'),
					series = $self.text();

				$self.closest('.list-series').find('.btn--primary').removeClass('btn--primary').addClass('btn--outline-primary');
				$self.removeClass('btn--outline-primary').addClass('btn--primary');

				$formSeries.find('[data-individual="series"]').val(series);

				return false;
			});
		}
	},

	serieDescription: function () {
		const description = document.querySelector('[data-serie-description]');
		if (!description) return;

		const content = description.querySelector('.vg-shop-serie__description-content');
		const toggle = description.querySelector('[data-serie-description-toggle]');
		const update = () => {
			const limit = window.innerWidth < 768 ? 260 : 300;
			description.style.setProperty('--serie-description-limit', `${limit}px`);
			const hasOverflow = content.scrollHeight > limit + 20;

			toggle.classList.toggle('d-none', !hasOverflow);
			if (!hasOverflow) {
				description.classList.remove('is-collapsed', 'is-expanded');
				toggle.setAttribute('aria-expanded', 'false');
				toggle.textContent = 'Читать полностью';
			} else if (!description.classList.contains('is-expanded')) {
				description.classList.add('is-collapsed');
			}
		};

		toggle.addEventListener('click', () => {
			const expanded = description.classList.toggle('is-expanded');
			description.classList.toggle('is-collapsed', !expanded);
			toggle.setAttribute('aria-expanded', String(expanded));
			toggle.textContent = expanded ? 'Свернуть' : 'Читать полностью';
		});

		update();
		window.addEventListener('load', update);
		window.addEventListener('resize', update);
	},

	fixedScrollTo: function ($self) {
		let $sticky = $('.vg-scroll-top'),
			scroll = $self.scrollTop();

		if (scroll > 400) {
			$sticky.addClass('is-active');
		} else {
			$sticky.removeClass('is-active');
		}
	},

	initHeader: function () {
		const header = document.querySelector('.vg-header');
		const wrapper = header?.querySelector('.vg-header-wrapper');
		const top = header?.querySelector('.vg-header-top');

		if (!wrapper || !top || Vegas.headerScrollState) {
			return;
		}

		Vegas.headerScrollState = {
			header,
			wrapper,
			top,
			lastScroll: null,
			direction: 0,
			distance: 0,
			isFixed: false,
			isVisible: false
		};

		Vegas.measureHeader();
		Vegas.fixedHeader($(window));
		window.addEventListener('resize', () => {
			Vegas.measureHeader();
			Vegas.fixedHeader($(window));
		});
	},

	measureHeader: function () {
		const state = Vegas.headerScrollState;

		if (!state) {
			return;
		}

		// Reserve the expanded height even when measuring the compact floating menu.
		const collapse = state.wrapper.style.getPropertyValue('--header-collapse');
		state.wrapper.style.setProperty('--header-collapse', '0');
		state.height = state.wrapper.offsetHeight;
		state.topHeight = state.top.offsetHeight;
		state.header.style.setProperty('--header-height', `${state.height}px`);
		state.wrapper.style.setProperty('--header-top-height', `${state.topHeight}px`);
		state.wrapper.style.setProperty('--header-collapse', collapse || '0');
	},

	fixedHeader: function ($self) {
		const state = Vegas.headerScrollState;

		if (!state) {
			return;
		}

		const scroll = Math.max(0, $self.scrollTop());
		const delta = state.lastScroll === null ? 0 : scroll - state.lastScroll;
		const wasFixed = state.isFixed;
		const collapse = Math.min(1, Math.max(0,
			(scroll - state.topHeight) / Math.max(1, state.height - state.topHeight)
		));

		// Expand during the approach to the original header so both sizes match on docking.
		state.wrapper.style.setProperty('--header-collapse', String(collapse));

		if (state.lastScroll === null && scroll > state.height) {
			state.isFixed = true;
			state.isVisible = true;
		}

		if (delta !== 0) {
			const direction = Math.sign(delta);

			if (direction !== state.direction) {
				state.direction = direction;
				state.distance = 0;
			}

			state.distance += Math.abs(delta);
		}

		if (scroll <= state.topHeight) {
			// The fixed main row and the original main row meet at the same position.
			state.isFixed = false;
			state.isVisible = false;
		} else if (!state.isFixed && scroll > state.height) {
			state.isFixed = true;
			state.isVisible = false;
		}

		if (state.isFixed) {
			if (scroll <= state.height || (state.direction < 0 && state.distance >= 12)) {
				state.isVisible = true;
			} else if (state.direction > 0 && state.distance >= 24) {
				state.isVisible = false;
			}
		}

		state.wrapper.classList.toggle('is-fixed', state.isFixed);
		state.wrapper.classList.toggle('is-scroll-animated', state.isFixed && wasFixed);
		state.wrapper.classList.toggle('is-visible', state.isFixed && state.isVisible);
		document.body.classList.toggle('vg-header-scroll', state.isFixed && state.isVisible);
		state.lastScroll = scroll;
	}
};
